<template>
  <v-card id="prapare">
    <v-banner>
      <h2 class="font-weight-bold primary--text pt-3 pb-4 text-capitalize">
        {{ $t("questions.title") }}
      </h2>
    </v-banner>
    <v-container class="px-5" fluid>
      <v-form ref="prapare" lazy-validation>
        <template v-if="step === 1">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="6">
              <h3>Personal Characteristics</h3>
              <!-- <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("personalCharacteristics.Q1") }}
                </p>
                <v-select
                  v-model="form.personalCharacteristicsQ1"
                  class="mt-0"
                  :items="$t('ethnicityAnswers')"
                  :label="$t('labels.select')"
                  item-text="text"
                  item-value="value"
                  required
                  :rules="rules"
                ></v-select>
              </v-col> -->
              <!-- end question -->
              <!-- <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("personalCharacteristics.Q2") }}
                </p>
                <v-row no-gutters>
                  <v-select
                    v-model="form.personalCharacteristicsQ2"
                    :items="$t('raceOptions')"
                    :label="$t('labels.select')"
                    item-text="text"
                    item-value="value"
                    multiple
                    required
                    @change="raceRule"
                  ></v-select>
                </v-row>
              </v-col> -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("personalCharacteristics.Q4") }}
                </p>
                <v-row no-gutters>
                  <v-col>
                    <v-radio-group
                      v-model="form.personalCharacteristicsQ4"
                      class="mt-0"
                      required
                      :rules="rules"
                    >
                      <v-radio
                        v-for="item in $t('personalCharacteristicsQ4')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                </v-row>
                <v-row v-if="form.personalCharacteristicsQ4 === 'Yes'">
                  <v-col>
                    <v-select
                      v-model="form.personalCharacteristicsQ4Details"
                      :items="$t('personalCharacteristicsQ4Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- question 5 -->
              <!-- <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("personalCharacteristics.Q5") }}
                </p>
                <v-row no-gutters>
                  <v-col :cols="6">
                    <v-radio-group
                      v-model="form.personalCharacteristicsQ5"
                      class="mt-0"
                      required
                    >
                      <v-radio
                        v-for="item in $t('personalCharacteristicsQ5')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.text"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col :cols="6">
                    <v-select
                      v-if="form.personalCharacteristicsQ5 === 'Yes'"
                      v-model="form.personalCharacteristicsQ5Details"
                      :items="$t('personalCharacteristicsQ5Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col> -->
            </v-col>
          </v-row>
        </template>
        <!-- <v-row no-gutters>
          <v-divider></v-divider>
        </v-row> -->
        <!-- family and home -->
        <template v-if="step === 1">
          <v-row no-gutters>
            <v-col cols="12" sm="12" md="6">
              <h3>{{ $t("header.familyAndHome") }}</h3>
              <!-- <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("familyAndHome.Q1") }}
                </p>
                <v-text-field
                  v-model="form.familyAndHomeQ1"
                  label="Enter a number"
                  type="number"
                  :rules="[numberRule]"
                ></v-text-field>
                <v-radio-group
                  v-model="form.familyAndHomeQ1"
                  class="mt-0"
                  required
                >
                  <v-radio
                  v-for="item in $t('familyAndHomeQ1')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></v-radio>
                  <v-radio
                    v-for="item in $t('optOut')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></v-radio>
                </v-radio-group>
              </v-col> -->
              <!-- end question -->
              <!-- question 3 -->
              <!-- <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("familyAndHome.Q3") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.familyAndHomeQ3"
                      class="mt-0"
                      required
                    >
                      <v-radio
                        v-for="item in $t('familyAndHomeQ3')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.text"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.text"
                      ></v-radio> </v-radio-group
                  ></v-col>
                  <v-col>
                    <v-select
                      v-if="form.familyAndHomeQ3 === 'I do not have housing'"
                      v-model="form.familyAndHomeQ3Details"
                      :items="$t('familyAndHomeQ3Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col> -->
              <!-- end question 3 -->
              <!-- question 4 -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("familyAndHome.Q4") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.familyAndHomeQ4"
                      class="mt-0"
                      required
                      :rules="rules"
                    >
                      <v-radio
                        v-for="item in $t('familyAndHomeQ4')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio> </v-radio-group
                  ></v-col>
                </v-row>
                <v-row v-if="form.familyAndHomeQ4 === 'Yes'">
                  <v-col>
                    <v-select
                      v-model="form.familyAndHomeQ4Details"
                      :items="$t('familyAndHomeQ4Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- end question 4 -->
            </v-col>
          </v-row>
        </template>
        <!-- <v-row no-gutters>
          <v-divider></v-divider>
        </v-row> -->
        <!-- Money and Resources -->
        <template v-if="step === 2">
          <v-row no-gutters class="mt-12">
            <v-col cols="12" sm="12" md="6">
              <h3>{{ $t("header.moneyAndResources") }}</h3>
              <!-- <v-col>
              <p class="mb-0 text-h6">
                {{ $t("moneyAndResources.Q1") }}
              </p>
              <v-text-field
                v-model="form.q1"
                label="Enter a number"
                type="number"
              ></v-text-field>
              <v-radio-group
                v-model="form.q1"
                class="mt-0"
                required
                :rules="[numberRule]"
              >
                <v-radio
                  v-for="item in $t('optOut')"
                  :key="item.value"
                  :label="item.text"
                  :value="item.value"
                ></v-radio>
              </v-radio-group>
            </v-col> -->
              <!-- end question -->
              <!-- question 2 -->
              <!-- <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("moneyAndResources.Q2") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.moneyAndResourcesQ2"
                      class="mt-0"
                      required
                    >
                      <v-radio
                        v-for="item in $t('moneyAndResourcesQ2')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.text"
                      ></v-radio> </v-radio-group
                  ></v-col>
                  <v-col>
                    <v-select
                      v-if="form.moneyAndResourcesQ2 === '200% or more'"
                      v-model="form.moneyAndResourcesQ2Details"
                      :items="$t('moneyAndResourcesQ2Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col> -->
              <!-- end question 2 -->
              <!-- question 3 -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("moneyAndResources.Q3") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.moneyAndResourcesQ3"
                      class="mt-0"
                      required
                      :rules="rules"
                    >
                      <v-radio
                        v-for="item in $t('moneyAndResourcesQ3')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio> </v-radio-group
                  ></v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-if="
                        form.moneyAndResourcesQ3 ===
                          'Less than high school degree'
                      "
                      v-model="form.moneyAndResourcesQ3Details"
                      :items="$t('moneyAndResourcesQ3LessThanDetails')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                    <v-select
                      v-if="
                        form.moneyAndResourcesQ3 ===
                          'High School Diploma or GED'
                      "
                      v-model="form.moneyAndResourcesQ3Details"
                      :items="$t('moneyAndResourcesQ3HighSchoolDetails')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                    <v-select
                      v-if="
                        form.moneyAndResourcesQ3 === 'More than high school'
                      "
                      v-model="form.moneyAndResourcesQ3Details"
                      :items="$t('moneyAndResourcesQ3MoreThanDetails')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- end question 3 -->
              <!-- question 4 -->
              <!-- <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("moneyAndResources.Q4") }}
                </p>
                <v-radio-group
                  v-model="form.moneyAndResourcesQ4"
                  class="mt-0"
                  required
                >
                  <v-radio
                    v-for="item in $t('moneyAndResourcesQ4')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.text"
                  ></v-radio>
                  <v-radio
                    v-for="item in $t('optOut')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.text"
                  ></v-radio>
                </v-radio-group>
              </v-col> -->
              <!-- end question 4 -->
              <!-- question 5 -->
              <!-- <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("moneyAndResources.Q5") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.moneyAndResourcesQ5"
                      class="mt-0"
                      required
                    >
                      <v-radio
                        v-for="item in $t('moneyAndResourcesQ5')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.text"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.text"
                      ></v-radio>
                    </v-radio-group>
                  </v-col>
                  <v-col>
                    <v-select
                      v-if="form.moneyAndResourcesQ5 === 'None/uninsured'"
                      v-model="form.moneyAndResourcesQ5Details"
                      :items="$t('moneyAndResourcesQ5Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col> -->
              <!-- end question 5 -->
              <!-- question 6 -->
              <v-col cols="12">
                <p class="mb-0 text-h6">
                  {{ $t("moneyAndResources.Q6") }}
                </p>

                <div
                  v-for="item in $t('moneyAndResourcesQ6')"
                  :key="item.value"
                >
                  <v-row class="mt-4">
                    <v-col :cols="6">
                      <v-checkbox
                        :label="item.text"
                        :value="'Yes'"
                        v-model="
                          form.moneyAndResourcesQ6[
                            item.value.replace(/\s/g, '')
                          ]
                        "
                        @change="moneyAndResourcesNullCheck()"
                      />
                    </v-col>
                  </v-row>

                  <v-row>
                    <v-col v-if="item.value !== 'Child Care'">
                      <v-select
                        :items="item.details"
                        item-text="text"
                        item-value="value"
                        label="Details"
                        solo
                        v-model="
                          form.moneyAndResourcesQ6Details[
                            item.value.replace(/\s/g, '')
                          ]
                        "
                      ></v-select>
                    </v-col>
                  </v-row>
                </div>

                <!-- Opt-out checkbox (disabled by you) -->
                <!--
  <v-checkbox
    v-for="item in $t('optOut')"
    :key="item.value"
    v-model="form.moneyAndResourcesQ6Choose"
    :label="item.text"
    :value="{}"
  ></v-checkbox>
  -->
              </v-col>
              <!-- end question 6 -->

              <!-- question 7 -->
              <!-- special case  -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("moneyAndResources.Q7") }}
                </p>
                <v-row>
                  <v-col>
                    <v-checkbox
                      v-for="item in $t('moneyAndResourcesQ7')"
                      :key="item.text"
                      v-model="form.moneyAndResourcesQ7"
                      :label="item.text"
                      :value="item.value"
                      :rules="q7Rule"
                      @change="moneyAndResourcesQ7Handle(item.text)"
                    ></v-checkbox>
                    <v-checkbox
                      v-for="item in $t('moneyAndResourcesQ7No')"
                      :key="item.text"
                      v-model="form.moneyAndResourcesQ7"
                      :label="item.text"
                      :value="item.value"
                      :rules="q7Rule"
                      @change="moneyAndResourcesQ7Handle(item.text)"
                    ></v-checkbox>
                    <v-checkbox
                      v-for="item in $t('optOut')"
                      :key="item.text"
                      v-model="form.moneyAndResourcesQ7"
                      :label="item.text"
                      :value="item.value"
                      @change="moneyAndResourcesQ7Handle(item.text)"
                    ></v-checkbox>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col>
                    <v-select
                      v-if="form.moneyAndResourcesQ7.includes('No')"
                      v-model="form.moneyAndResourcesQ7NoDetails"
                      :items="$t('moneyAndResourcesQ7NoDetails')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                    <v-select
                      v-if="
                        form.moneyAndResourcesQ7.includes(
                          'Yes, it has kept me from medical appointments or from getting my medications'
                        ) ||
                          form.moneyAndResourcesQ7.includes(
                            'Yes, it has kept me from non-medical meetings, appointments, work, or from getting things that I need'
                          )
                      "
                      v-model="form.moneyAndResourcesQ7Details"
                      :items="$t('moneyAndResourcesQ7Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- end question 7 -->
            </v-col>
          </v-row>
        </template>
        <!-- End Money and resources -->
        <!-- <v-row no-gutters>
          <v-divider></v-divider>
        </v-row> -->
        <!-- Social And Emotional Health -->
        <template v-if="step === 3">
          <v-row no-gutters class="mt-12">
            <v-col cols="12" sm="12" md="6">
              <h3>{{ $t("header.socialAndEmotionalHealth") }}</h3>
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("socialAndEmotionalHealth.Q1") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.socialAndEmotionalHealthQ1"
                      class="mt-0"
                      required
                      :rules="rules"
                    >
                      <v-radio
                        v-for="item in $t('socialAndEmotionalHealthQ1')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio> </v-radio-group
                  ></v-col>
                  <v-col>
                    <v-select
                      v-if="
                        form.socialAndEmotionalHealthQ1 ===
                          'Less than once a week'
                      "
                      v-model="form.socialAndEmotionalHealthQ1Details"
                      :items="$t('socialAndEmotionalHealthQ1Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      required
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- end question -->
              <!-- question 2 -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("socialAndEmotionalHealth.Q2") }}
                </p>

                <v-radio-group
                  v-model="form.socialAndEmotionalHealthQ2"
                  class="mt-0"
                  required
                  :rules="rules"
                >
                  <v-radio
                    v-for="item in $t('socialAndEmotionalHealthQ2')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></v-radio>
                  <v-radio
                    v-for="item in $t('optOut')"
                    :key="item.value"
                    :label="item.text"
                    :value="item.value"
                  ></v-radio>
                </v-radio-group>
              </v-col>
              <!-- end question 2 -->
            </v-col>
          </v-row>
        </template>
        <!-- End Social And Emotional Health -->
        <!-- <v-row no-gutters>
          <v-divider></v-divider>
        </v-row> -->
        <!-- optional questions  -->
        <template v-if="step === 4">
          <v-row no-gutters class="mt-12">
            <v-col cols="12" sm="12" md="6">
              <h3>{{ $t("header.optional") }}</h3>
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("optionalAdditionalQuestions.Q1") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.optionalAdditionalQuestionsQ1"
                      class="mt-0"
                    >
                      <v-radio
                        v-for="item in $t('optionalAdditionalQuestionsQ1')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio> </v-radio-group
                  ></v-col>
                </v-row>
                <v-row v-if="form.optionalAdditionalQuestionsQ1 === 'Yes'">
                  <v-col>
                    <v-select
                      v-model="form.optionalAdditionalQuestionsQ1Details"
                      :items="$t('optionalAdditionalQuestionsQ1Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- end question -->
              <!-- question 2 -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("optionalAdditionalQuestions.Q2") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.optionalAdditionalQuestionsQ2"
                      class="mt-0"
                    >
                      <v-radio
                        v-for="item in $t('optionalAdditionalQuestionsQ2')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio> </v-radio-group
                  ></v-col>
                </v-row>
                <v-row v-if="form.optionalAdditionalQuestionsQ2 === 'Yes'">
                  <v-col>
                    <v-select
                      v-model="form.optionalAdditionalQuestionsQ2Details"
                      :items="$t('optionalAdditionalQuestionsQ2Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- end question 2 -->
              <!-- question 3 -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("optionalAdditionalQuestions.Q3") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.optionalAdditionalQuestionsQ3"
                      class="mt-0"
                    >
                      <v-radio
                        v-for="item in $t('optionalAdditionalQuestionsQ3')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio> </v-radio-group
                  ></v-col>
                </v-row>
                <v-row v-if="form.optionalAdditionalQuestionsQ3 === 'No'">
                  <v-col>
                    <v-select
                      v-model="form.optionalAdditionalQuestionsQ3Details"
                      :items="$t('optionalAdditionalQuestionsQ3Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- end question 3 -->
              <!-- question 4 -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("optionalAdditionalQuestions.Q4") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.optionalAdditionalQuestionsQ4"
                      class="mt-0"
                    >
                      <v-radio
                        v-for="item in $t('optionalAdditionalQuestionsQ4')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio>
                      <v-radio
                        v-for="item in $t('optOut')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio> </v-radio-group
                  ></v-col>
                </v-row>
                <v-row v-if="form.optionalAdditionalQuestionsQ4 === 'Yes'">
                  <v-col>
                    <v-select
                      v-model="form.optionalAdditionalQuestionsQ4Details"
                      :items="$t('optionalAdditionalQuestionsQ4Details')"
                      :label="$t('labels.select')"
                      item-text="text"
                      item-value="value"
                      solo
                    ></v-select>
                  </v-col>
                </v-row>
              </v-col>
              <!-- end question 4-->
              <!-- question 5 -->
              <v-col>
                <p class="mb-0 text-h6">
                  {{ $t("questions.contactCaseManagers") }}
                </p>
                <v-row>
                  <v-col>
                    <v-radio-group
                      v-model="form.contactCaseManagers"
                      class="mt-0"
                    >
                      <v-radio
                        v-for="item in $t('yesNo')"
                        :key="item.value"
                        :label="item.text"
                        :value="item.value"
                      ></v-radio> </v-radio-group
                  ></v-col>
                </v-row>
              </v-col>
              <!-- end question 5-->
            </v-col>
          </v-row>
        </template>
        <!-- end optional questions -->
        <v-row no-gutters>
          <v-divider></v-divider>
        </v-row>

        <!-- <v-row>
          <v-spacer></v-spacer>
          <v-btn
            class="success"
            :loading="loading"
            @click="validatePRAPARE()"
            >{{ $t("button.submitAnswers") }}</v-btn
          >
        </v-row> -->
      </v-form>
      <v-card-actions class="px-0">
        <v-spacer></v-spacer>
        <v-btn @click="step--" v-if="step !== 1" text>Back</v-btn>
        <v-btn @click="validatePRAPARE()" :loading="loading" color="primary">{{
          buttonText
        }}</v-btn>
      </v-card-actions>
    </v-container>
  </v-card>
</template>

<script>
export default {
  name: "PRAPARE",

  props: {
    expiration: {
      default: null,
      type: String,
    },
    formId: {
      default: null,
      type: String,
    },
  },
  i18n: {
    messages: require("@/plugins/i18n/PRAPARE.json"),
  },
  data: function() {
    return {
      step: 1,
      success: false,
      loading: false,
      dialog: false,
      valid: false,
      resources: false,
      rules: [(v) => !!v || this.$i18n.t("labels.missing")],
      numberRule: (v) => {
        if (!isNaN(parseFloat(v)) && v >= 0) return true;
        return this.$i18n.t("labels.number");
      },
      // check  for ethnicity rules maybe
      raceRule: (ethnicity) => {
        if (
          ethnicity[ethnicity.length - 1].includes("Declined to specify") &&
          this.form.personalCharacteristicsQ2.length > 1
        ) {
          this.form.personalCharacteristicsQ2 = this.form.personalCharacteristicsQ2.filter(
            (item) => item == "Declined to specify"
          );
        } else {
          this.form.personalCharacteristicsQ2 = this.form.personalCharacteristicsQ2.filter(
            (item) => item !== "Declined to specify"
          );
        }
      },
      moneyAndResourcesQ7Handle: (clicked) => {
        const NO = "No";
        const SKIP = "I choose not to answer this question";

        if (clicked === NO) {
          this.form.moneyAndResourcesQ7 = [NO];

          this.form.moneyAndResourcesQ7No = NO;

          this.form.moneyAndResourcesQ7Choose = null;
          this.form.moneyAndResourcesQ7Medical = null;
          this.form.moneyAndResourcesQ7NonMedical = null;
          this.form.moneyAndResourcesQ7Details = null;
          this.form.moneyAndResourcesQ7NoDetails = null;

          return;
        }

        if (clicked === SKIP) {
          this.form.moneyAndResourcesQ7 = [SKIP];

          this.form.moneyAndResourcesQ7No = null;

          this.form.moneyAndResourcesQ7Choose = SKIP;
          this.form.moneyAndResourcesQ7Medical = null;
          this.form.moneyAndResourcesQ7NonMedical = null;
          this.form.moneyAndResourcesQ7Details = null;
          this.form.moneyAndResourcesQ7NoDetails = null;

          return;
        }

        this.form.moneyAndResourcesQ7 = this.form.moneyAndResourcesQ7.filter(
          (v) => v !== NO && v !== SKIP
        );

        this.form.moneyAndResourcesQ7No = null;

        this.form.moneyAndResourcesQ7Choose = null;
        this.form.moneyAndResourcesQ7NoDetails = null;
      },
      q7Rule: [
        (v) =>
          this.form.moneyAndResourcesQ7.length !== 0 ||
          this.$i18n.t("labels.missing"),
      ],
      receivedForm: [],
      form: {
        id: this.formId,
        url: this.$route.params.id,
        formName: "PRAPARE",
        personalCharacteristicsQ1: null,
        personalCharacteristicsQ2: null,
        // personalCharacteristicsQ3: undefined,
        personalCharacteristicsQ4: null,
        personalCharacteristicsQ4Details: null,
        personalCharacteristicsQ5: null,
        personalCharacteristicsQ5Details: null,
        familyAndHomeQ1: null,
        // familyAndHomeQ2: undefined,
        familyAndHomeQ3: null,
        familyAndHomeQ3Details: null,
        familyAndHomeQ4: null,
        familyAndHomeQ4Details: null,
        // moneyAndResourcesQ1: undefined,
        // write a calculation based on formula and stop user from being able to answer or let them answer unknown and calculate for them
        moneyAndResourcesQ2: null,
        moneyAndResourcesQ2Details: null,
        moneyAndResourcesQ3: null,
        moneyAndResourcesQ3Details: null,
        moneyAndResourcesQ4: null,
        moneyAndResourcesQ5: null,
        moneyAndResourcesQ5Details: null,
        moneyAndResourcesQ6: {},
        moneyAndResourcesQ6Details: {},
        // special case doubel check
        moneyAndResourcesQ7: [],
        moneyAndResourcesQ7Medical: null,
        moneyAndResourcesQ7NonMedical: null,
        moneyAndResourcesQ7No: null,
        moneyAndResourcesQ7Details: null,
        moneyAndResourcesQ7NoDetails: null,
        moneyAndResourcesQ7Choose: null,
        socialAndEmotionalHealthQ1: null,
        socialAndEmotionalHealthQ1Details: null,
        socialAndEmotionalHealthQ2: null,
        socialAndEmotionalHealthQ2Details: null,
        optionalAdditionalQuestionsQ1: null,
        optionalAdditionalQuestionsQ1Details: null,
        optionalAdditionalQuestionsQ2: null,
        optionalAdditionalQuestionsQ2Details: null,
        optionalAdditionalQuestionsQ3: null,
        optionalAdditionalQuestionsQ3Details: null,
        optionalAdditionalQuestionsQ4: null,
        optionalAdditionalQuestionsQ4Details: null,
        contactCaseManagers: null,
        q1: undefined,
        q2: undefined,
        q3: undefined,
        q4: undefined,
        q5: undefined,
        q6: undefined,
        q7: undefined,
        q8: undefined,
        q9: undefined,
        q10: undefined,
        q11: undefined,
        q12: undefined,
        q13: undefined,
        q14: undefined,
        q15: undefined,
        q16: undefined,
        q17: undefined,
        q18: undefined,
        q19: undefined,
        q20: undefined,
        q21: undefined,
        q22: undefined,
        // moneyAndResources: {},
      },
    };
  },
  computed: {
    buttonText() {
      if (this.step !== 4) {
        return "Next";
      } else {
        return "Submit";
      }
    },
  },
  watch: {
    "form.personalCharacteristicsQ1"(value, oldvalue) {
      if (value === "Hispanic or Latino") {
        this.form.q1 = 1;
      } else {
        this.form.q1 = 0;
      }
    },
    "form.personalCharacteristicsQ2"(value, oldvalue) {
      // this is an array
      if (value.includes("White") && value.length <= 1) {
        this.form.q2 = 0;
      } else {
        this.form.q2 = 1;
      }
    },
    // "form.personalCharacteristicsQ3"(value, oldvalue) {
    //   if (value === "Yes") {
    //     this.form.q3 = 1;
    //   } else {
    //     this.form.q3 = 0;
    //   }
    // },
    "form.personalCharacteristicsQ4"(value, oldvalue) {
      this.form.personalCharacteristicsQuestion4 =
        "Have you been discharged from the armed forces of the United States?";
      if (value === "Yes") {
        this.form.q4 = 1;
      } else {
        this.form.q4 = 0;
        this.form.personalCharacteristicsQ4Details = null;
      }
    },
    "form.personalCharacteristicsQ5"(value, oldvalue) {
      if (value === "Yes") {
        this.form.q5 = 1;
      } else {
        this.form.q5 = 0;
      }
    },
    // family and home
    // q6 here is used to calculate fpl
    "form.familyAndHomeQ1"(value, oldvalue) {},
    // address q7
    // "form.familyAndHomeQ2"(value, oldvalue) {
    //   if (value === "Hispanic or Latino") {
    //     this.form.q1 = 1;
    //   } else {
    //     this.form.q1 = 0;
    //   }
    // },
    "form.familyAndHomeQ3"(value, oldvalue) {
      if (value === "I do not have housing") {
        this.form.q8 = 1;
      } else {
        this.form.q8 = 0;
      }
    },
    "form.familyAndHomeQ4"(value, oldvalue) {
      this.form.familyAndHomeQuestion4 =
        "Are you worried about losing your housing?";
      if (value === "Yes") {
        this.form.q9 = 1;
      } else {
        this.form.q9 = 0;
        this.form.familyAndHomeQ4Details = null;
      }
    },
    // total income q10
    // "form.moneyAndResourcesQ1"(value, oldvalue) {
    //   if (value === "i do not have housing") {
    //     this.form.q = 1;
    //   } else {
    //     this.form.q1 = 0;
    //   }
    // },
    // federal poverty level q11
    // "form.moneyAndResourcesQ2"(value, oldvalue) {
    //   if (value === "Hispanic or Latino") {
    //     this.form.q1 = 1;
    //   } else {
    //     this.form.q1 = 0;
    //   }
    // },
    "form.moneyAndResourcesQ3"(value, oldvalue) {
      this.form.moneyAndResourcesQuestion4 =
        "What is the highest level of school that you have finished?";
      if (value === "Less than high school degree") {
        this.form.q12 = 1;
      } else {
        this.form.q12 = 0;
      }
    },
    "form.moneyAndResourcesQ4"(value, oldvalue) {
      if (value === "Unemployed" || value === "Part-time or temporary work") {
        this.form.q13 = 1;
      } else {
        this.form.q13 = 0;
      }
    },
    "form.moneyAndResourcesQ5"(value, oldvalue) {
      if (value === "None/uninsured") {
        this.form.q14 = 1;
      } else {
        this.form.q14 = 0;
      }
    },
    // unable to get q15
    "form.moneyAndResourcesQ6"(value) {
      const countYes = Object.values(value).filter((v) => v === "Yes").length;
      this.form.q15 = countYes;
    },
    "form.moneyAndResourcesQ6Details": {
      deep: true,
      handler(value) {
        const items = this.$t("moneyAndResourcesQ6");

        items.forEach((item) => {
          const key = item.value.replace(/\s/g, "");
          const detailSelected = this.form.moneyAndResourcesQ6Details[key];

          if (detailSelected) {
            this.form.moneyAndResourcesQ6[key] = "Yes";
          }
        });
      },
    },
    // lack of transport q16
    "form.moneyAndResourcesQ7"(value, oldvalue) {
      this.form.moneyAndResourcesQuestion7 =
        "Has lack of transportation kept you from medical appointments, meetings,work, or from getting things needed for daily living? Check all that apply.";
      let containsYes = value.some((element) => element.includes("Yes"));
      if (containsYes) {
        this.form.q16 = value.length;
      } else {
        this.form.q16 = 0;
      }
      if (
        value.includes(
          "Yes, it has kept me from medical appointments or from getting my medications"
        )
      ) {
        this.form.moneyAndResourcesQ7Medical =
          "Yes, it has kept me from medical appointments or from getting my medications";
      }
      if (
        value.includes(
          "Yes, it has kept me from non-medical meetings, appointments, work, or from getting things that I need"
        )
      ) {
        this.form.moneyAndResourcesQ7NonMedical =
          "Yes, it has kept me from non-medical meetings, appointments, work, or from getting things that I need";
      }
    },
    "form.socialAndEmotionalHealthQ1"(value, oldvalue) {
      if (
        value === "Less than once a week" ||
        value === "1 or 2 times a week"
      ) {
        this.form.q17 = 1;
      } else {
        this.form.q17 = 0;
        this.form.socialAndEmotionalHealthQ1Details = null;
      }
    },
    "form.socialAndEmotionalHealthQ2"(value, oldvalue) {
      if (value === "Quite a bit" || value === "Very much") {
        this.form.q18 = 1;
      } else {
        this.form.q18 = 0;
      }
    },
    "form.optionalAdditionalQuestionsQ1"(value, oldvalue) {
      if (value === "Yes") {
        this.form.q19 = 1;
      } else {
        this.form.q19 = 0;
        this.form.optionalAdditionalQuestionsQ1Details = null;
      }
    },
    "form.optionalAdditionalQuestionsQ2"(value, oldvalue) {
      if (value === "Yes") {
        this.form.q20 = 1;
      } else {
        this.form.q20 = 0;
        this.form.optionalAdditionalQuestionsQ2Details = null;
      }
    },
    "form.optionalAdditionalQuestionsQ3"(value, oldvalue) {
      if (value === "No") {
        this.form.q21 = 1;
      } else {
        this.form.q21 = 0;
        this.form.optionalAdditionalQuestionsQ3Details = null;
      }
    },
    "form.optionalAdditionalQuestionsQ4"(value, oldvalue) {
      if (value === "Yes") {
        this.form.q22 = 1;
      } else {
        this.form.q22 = 0;
        this.form.optionalAdditionalQuestionsQ4Details = null;
      }
    },
  },
  mounted() {
    this.form.form_id = this.$route.params.receivedForm.form_id;
    this.form.id = this.$route.params.receivedForm.id;
    this.form.url = this.$route.params.receivedForm.url;
    this.form.expires_on = this.$route.params.receivedForm.expires_on;
  },
  methods: {
    validatePRAPARE() {
      const valid = this.$refs.prapare.validate();
      if (valid) {
        if (this.step === 4) {
          this.form.formName = "PRAPARE";
          this.form.total = this.getTotal(this.form);

          if (
            this.form.moneyAndResourcesQ6.Food === null ||
            !("Food" in this.form.moneyAndResourcesQ6)
          ) {
            this.form.moneyAndResourcesQ6.Food = "No";
          }
          if (
            this.form.moneyAndResourcesQ6.Utilities === null ||
            !("Utilities" in this.form.moneyAndResourcesQ6)
          ) {
            this.form.moneyAndResourcesQ6.Utilities = "No";
          }
          if (
            this.form.moneyAndResourcesQ6.Clothing === null ||
            !("Clothing" in this.form.moneyAndResourcesQ6)
          ) {
            this.form.moneyAndResourcesQ6.Clothing = "No";
          }
          if (
            this.form.moneyAndResourcesQ6.ChildCare === null ||
            !("ChildCare" in this.form.moneyAndResourcesQ6)
          ) {
            this.form.moneyAndResourcesQ6.ChildCare = "No";
          }
          if (
            this.form.moneyAndResourcesQ6.MedicineorAnyHealthcare === null ||
            !("MedicineorAnyHealthcare" in this.form.moneyAndResourcesQ6)
          ) {
            this.form.moneyAndResourcesQ6.MedicineorAnyHealthcare = "No";
          }
          if (
            this.form.moneyAndResourcesQ6.Phone === null ||
            !("Phone" in this.form.moneyAndResourcesQ6)
          ) {
            this.form.moneyAndResourcesQ6.Phone = "No";
          }
          this.submit();
        } else {
          this.$vuetify.goTo("#prapare");
          this.step++;
        }
      }
    },
    moneyAndResourcesNullCheck() {
      const q6 = this.form.moneyAndResourcesQ6;
      Object.keys(q6).forEach((key) => {
        if (q6[key] !== "Yes") {
          q6[key] = null;
        }
      });

      this.$nextTick(() => {
        const q6 = this.form.moneyAndResourcesQ6;
        const details = this.form.moneyAndResourcesQ6Details;

        Object.keys(q6).forEach((key) => {
          if (q6[key] !== "Yes") {
            details[key] = null;
          }
        });
      });
    },
    getTotal(form) {
      let questions = Object.keys(form)
        .filter((v) => v.startsWith("q"))
        .map((e) => form[e]);
      const sumValues = (obj) => Object.values(obj).reduce((a, b) => a + b);
      return sumValues(questions);
    },
    submit() {
      this.loading = true;
      if (this.form.expires_on >= this.moment().toISOString()) {
        this.axios
          .post("/forms", { form: this.form })
          .then(() => {
            this.$emit("formSuccess", true);
          })
          .catch((error) => {
            console.log(error);
          })
          .finally(() => {
            this.loading = false;
          });
      } else {
        this.$router.push({
          name: "forms",
          params: { id: this.$route.params.id },
        });
      }
    },
  },
};
</script>
<style scoped>
::v-deep .v-list-item .v-list-item__title,
.v-list-item .v-list-item__subtitle {
  font-weight: 500;
}
</style>
